import image11 from '../../assets/photo/1-1.jpg';
import image12 from '../../assets/photo/1-2.jpg';
import image13 from '../../assets/photo/1-3.jpg';
import image14 from '../../assets/photo/1-4.jpg';
import image21 from '../../assets/photo/2-1.jpg';
import image22 from '../../assets/photo/2-2.jpg';
import image23 from '../../assets/photo/2-3.jpg';
import image24 from '../../assets/photo/2-4.jpg';
import image31 from '../../assets/photo/3-1.jpg';
import image32 from '../../assets/photo/3-2.jpg';
import image33 from '../../assets/photo/3-3.jpg';
import image34 from '../../assets/photo/3-4.jpg';
import image41 from '../../assets/photo/4-1.jpg';
import image42 from '../../assets/photo/4-2.jpg';
import image43 from '../../assets/photo/4-3.jpg';
import image44 from '../../assets/photo/4-4.jpg';
import image51 from '../../assets/photo/5-1.jpg';
import image52 from '../../assets/photo/5-2.jpg';
import image53 from '../../assets/photo/5-3.jpg';
import image54 from '../../assets/photo/5-4.jpg';

const photoList = {
  '1-1': image11,
  '1-2': image12,
  '1-3': image13,
  '1-4': image14,
  '2-1': image21,
  '2-2': image22,
  '2-3': image23,
  '2-4': image24,
  '3-1': image31,
  '3-2': image32,
  '3-3': image33,
  '3-4': image34,
  '4-1': image41,
  '4-2': image42,
  '4-3': image43,
  '4-4': image44,
  '5-1': image51,
  '5-2': image52,
  '5-3': image53,
  '5-4': image54,
};

export default photoList;
